<template>
	<modal ref="modal">
		<template #title>{{action.toUpperCase()}} VIDEO LIVE SCHEDULE</template>
		<template #body>
					<div class="form-floating mb-4">
						<select v-model="form.membership_level" class="form-select">
							<option value="ALL">ALL</option>
							<option value="SILVER">SILVER</option>
							<option value="GOLD">GOLD</option>
							<option value="DIAMOND">DIAMOND</option>
							<option value="PLATINUM">PLATINUM</option>
						</select>
						<label class="form-label" for="membership_level">Membership Level</label>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.host_by" id="host_by" name="host_by" class="form-control" placeholder="Host By" />
						<label class="form-label" for="host_by">Host By</label>
					</div>
					<div class="form-floating mb-4">
						<input type="text" v-model="form.title" id="title" name="title" class="form-control" placeholder="Title" />
						<label class="form-label" for="title">Title</label>
					</div>
					<div class="form-floating mb-4">
						<flat-pickr
							v-model="form.start_datetime"
							:config="{
								enableTime: true,
								altInput: true,
								altFormat: 'M j, Y h:i K',
								dateFormat: 'Y-m-d H:i:s',
							}"
							class="form-control"
							:class="
								form.errors.start_datetime
									? 'flatpickr-input is-invalid border-danger'
									: 'flatpickr-input'
							"
						/>
						<label class="form-label" for="start_datetime">Start DateTime</label>
					</div>
					<div class="form-floating mb-4">
						<flat-pickr
							v-model="form.end_datetime"
							:config="{
								enableTime: true,
								altInput: true,
								altFormat: 'M j, Y h:i K',
								dateFormat: 'Y-m-d H:i:s',
							}"
							class="form-control"
							:class="
								form.errors.end_datetime
									? 'flatpickr-input is-invalid border-danger'
									: 'flatpickr-input'
							"
						/>
						<label class="form-label" for="end_datetime">End DateTime</label>
					</div>
					<div class="form-group mb-4">
						<label class="form-label" for="is_active">Status</label>
						<div class="mt-2">
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_active"
									id="is_active_on"
									name="is_active"
									class="form-check-input"
									type="radio"
									value="1"
								/>
								<label class="form-check-label bg-alt-primary" for="ON">ON</label>
							</div>
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_active"
									id="is_active_off"
									name="is_active"
									class="form-check-input"
									type="radio"
									value="0"
								/>
								<label class="form-check-label bg-alt-primary" for="OFF">OFF</label>
							</div>
						</div>
					</div>
				
		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Content</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}
		
		const action = ref('add');

		const form = useForm({
			live_sched_id: 0,
			membership_level: "ALL",
			host_by 		: null,
			title 			: null,
			start_datetime 	: null,
			end_datetime 	: null,
			is_active 		: 1
		})

		const actionContent = ()=>{

			if(action.value=='add')
			{
				addContent();
			}else
			{
				updateContent();	
			}

		}

		const addContent = () => {
			form.post(route('admin.post.video-live-schedule'), {
				preserveState: true,
				preserveScroll: true,
				only:['contents,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateContent = () => {
			form.put('video-live-schedule/'+form.live_sched_id, {
				preserveState: true,
				preserveScroll: true,
				only:['contents,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setVideoLiveSchedule = (_action,data)=>{
								
								form.reset();

								action.value = _action;

								if(_action=='update')
								{
									form.live_sched_id 		= data.live_sched_id;
									form.membership_level 	= data.membership_level;
									form.host_by 			= data.host_by;
									form.title 				= data.title;
									form.start_datetime 	= data.start_datetime;
									form.end_datetime 		= data.end_datetime;
									form.is_active 			= data.is_active;
								}
								
							}


		return {
			form,
			modal,
			toggleModal,
			action,
			setVideoLiveSchedule,
			actionContent,
			addContent,
			updateContent,
		}
	},
}
</script>
